export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtSNND';
export const NAME = 'ServisniPaketyNd';
